import { Timestamp } from '@principle-theorem/shared';

export enum DatabaseStatus {
  Running = 'Running',
  Stopped = 'Stopped',
  Starting = 'Starting',
  Stopping = 'Stopping',
  Provisioning = 'Provisioning',
  Failed = 'Failed',
}

export const PENDING_DATABASE_STATUSES = [
  DatabaseStatus.Starting,
  DatabaseStatus.Stopping,
];

export const UNREACHABLE_DATABASE_STATUSES = [
  DatabaseStatus.Provisioning,
  DatabaseStatus.Failed,
];

export const DATABASE_STATUS_MAP: Record<
  Exclude<
    DatabaseStatus,
    | DatabaseStatus.Stopping
    | DatabaseStatus.Starting
    | DatabaseStatus.Provisioning
    | DatabaseStatus.Failed
  >,
  string
> = {
  [DatabaseStatus.Running]: 'ALWAYS',
  [DatabaseStatus.Stopped]: 'NEVER',
};

export type ActivatableDatabaseStatus = keyof typeof DATABASE_STATUS_MAP;

export enum DatabaseUpdateSource {
  PubSub = 'pubSub',
  UserInitiated = 'userInitiated',
  Cron = 'cron',
  IdleChecker = 'idleChecker',
  TaskQueue = 'taskQueue',
}

export interface IDatabaseInstanceDocument {
  instanceName: string;
  region: string;
  isDefault: boolean;
  status: DatabaseStatus;
  lastUpdated: Timestamp;
  lastUpdatedBy: DatabaseUpdateSource;
  pendingSince?: Timestamp;
}
